export default "__VITE_ASSET__rnKIoxVH__";